import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from "styled-components";
import { AppContext } from '../../contexts/AppContext';
import {Box, makeStyles} from '@material-ui/core';
import Text from './Text';
import Colors from '../../helpers/Colors';
import { Tab, Tabs, TabList } from 'react-tabs';
import { fetchFulfilledOrders } from '../../services/OrderService';
import { sortCompleteOrders } from '../../helpers/Util';
import Table from './table/Table';
import {getApplicableCompletedOrdersWithAssignerMode} from "../../helpers/OrderHelper";
import {BottomPagination} from "./table/BottomPagination";

const Wrapper = styled.div`
background-color: #FFFFFF;
height: 100%;
overflow: auto;
width: 100%;
`;


export function TabView() {
    const classes = useStyles();
    const {
        selectedTab,
        setSelectedTab,
        setCompletedOrders,
        kitchen,
        orders,
        completedOrders,
        overTimeOrderCount,
        setScrollContainer,
        isAssignerMode,
        searchText,
        setCompletedTabCurrentPage,
        completedTabCurrentPage,
        completedTabPageSize
    } = useContext(AppContext);
    const scrollRef = useRef();
    const [completedPages, setCompletedPages] = useState(0);

    const onTabChange = (tab) => {
        setSelectedTab(tab);
    }

    const fetchCompletedOrders = (pageNumber, externalId = "") => {
        fetchFulfilledOrders(kitchen, isAssignerMode ? 'prepared' : 'fulfilled', pageNumber, completedTabPageSize, externalId)
            .then((response) => {
                const eligibleOrders = isAssignerMode? getApplicableCompletedOrdersWithAssignerMode(response.content) : response.content;
                setCompletedOrders(sortCompleteOrders(eligibleOrders));
                setCompletedPages(response.totalPages)
            });
    }

    useEffect(() => {
        setScrollContainer(scrollRef);
    }, [scrollRef]);

    useEffect(() => {
        if (selectedTab === 1) {
            fetchCompletedOrders(0, searchText)
            setCompletedTabCurrentPage(1)
        }
    }, [completedTabPageSize, searchText, selectedTab])

    const handleCompletedTabPageChange = (event, page) => {
        setCompletedTabCurrentPage(page)
        if (fetchCompletedOrders) {
            fetchCompletedOrders(page - 1)
        }
    }

    return (
        <Wrapper ref={scrollRef}>
            <Tabs onSelect={index => onTabChange(index)} className={classes.container}>
                <div>
                    <TabList style={{ backgroundColor: 'rgb(238, 238, 238)', position: 'relative', padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                        <Box className={classes.tabsContainer}>
                            <Tab className={classes.tabButtonContainer}>
                                <Box className={classes.tabButtonContentContainer}>
                                    <Text className={selectedTab === 0 ? classes.selectedTabLabel : classes.tabLabel} >WAITING FOR PICKUP</Text>
                                    {overTimeOrderCount > 0 && (
                                        <Box className={classes.badgeView}>
                                            <Text className={classes.badgeLabel}>{overTimeOrderCount}</Text>
                                        </Box>
                                    )}
                                </Box>
                                <Box className={selectedTab === 0 ? classes.selectedUnderline : classes.unselectedUnderline}></Box>
                            </Tab>
                            <Tab className={classes.tabButtonContainer}>
                                <Box className={classes.tabButtonContentContainer}>
                                    <Text className={selectedTab === 1 ? classes.selectedTabLabel : classes.tabLabel}>COMPLETED</Text>
                                </Box>
                                <Box className={selectedTab === 1 ? classes.selectedUnderline : classes.unselectedUnderline}></Box>
                            </Tab>
                        </Box>
                    </TabList>
                </div>
                <div className={classes.panelsContainer} style={selectedTab === 1 ? {overflow: 'auto'}: {}}>
                    <div className={selectedTab === 0 ? classes.displayPanel : classes.hidePanel}>
                        {orders.length > 0 && (
                            <Table
                                type={'pickup'}
                            />
                        )}
                    </div>

                    <div className={selectedTab === 1 ? classes.displayPanel : classes.hidePanel}>
                        <Box height='100%' display='flex' flexDirection='column'>
                            <Box height='100vh' overflow='auto'>
                                {completedOrders.length > 0 && (
                                    <Table
                                        type={'completed'}
                                    />
                                )}
                            </Box>
                            <BottomPagination pageCnt={completedPages} currentPage={completedTabCurrentPage} handlePageChange={handleCompletedTabPageChange}/>
                        </Box>
                    </div>
                </div>
            </Tabs>

        </Wrapper>
    );
}


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: '##F6F6F6',
    },
    appBar: {
        backgroundColor: '#f6f6f6',

        '& .MuiTabs-indicator': {
            backgroundColor: Colors.blue,
        }
    },
    container: {
        height: '100%',
        display: 'flex',
        flexDirection:'column',
        '& .MuiSelect-selectMenu': {
            padding: 0
        }
    },
    tabLabel: {
        color: Colors.textColor,
        fontSize: 16,
        fontFamily: 'DINNextLTPro-Regular',
        fontWeight: 'bold',
    },
    selectedTabLabel: {
        color: '#0091FF',
        fontSize: 16,
        fontFamily: 'DINNextLTPro-Regular',
        fontWeight: 'bold',
    },
    tabsContainer: {
        cursor: 'pointer',
        display: 'flex',
        margin: 0,
        flexDirection: 'row',
        height: 60,
    },
    tabButtonContainer: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        width: '25vw',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        marginRight: 10,
    },
    badgeView: {
        height: 18,
        width: 18,
        borderRadius: 18,
        backgroundColor: Colors.red,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        right: -17,
        top: -5,
    },
    unselectedUnderline: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: 3,
        width: '25vw',
        backgroundColor: '#e1e1e1',
        borderRadius: 2,
    },
    selectedUnderline: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: 3,
        width: '25vw',
        backgroundColor: '#0091FF',
        borderRadius: 2,
    },
    badgeLabel: {
        color: Colors.white,
        fontSize: 12,
    },
    tabButtonContentContainer: {
        position: 'relative',
    },
    panelsContainer: {
        position: 'relative',
        height: '100%'
    },
    displayPanel: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 1,
    },
    hidePanel: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: -1,
        display: 'none',
    },
}));
